// utils/truncateHTML.js
export function truncateHTML(html, limit = 150) {
  if (!html) return "";

  // Simple regex-based fallback that works in SSR
  if (typeof window === "undefined") {
    // Strip HTML tags and truncate plain text during SSR
    const text = html.replace(/<[^>]+>/g, "");
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  }

  // Browser-side DOM parsing for preserving structure
  const div = document.createElement("div");
  div.innerHTML = html;

  let truncated = "";
  let length = 0;

  function traverse(node) {
    for (const child of node.childNodes) {
      if (length >= limit) break;

      if (child.nodeType === Node.TEXT_NODE) {
        const remaining = limit - length;
        if (child.textContent.length <= remaining) {
          truncated += child.textContent;
          length += child.textContent.length;
        } else {
          truncated += child.textContent.substring(0, remaining) + "...";
          length = limit;
        }
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const tagName = child.nodeName.toLowerCase();
        truncated += `<${tagName}${getAttributes(child)}>`;
        traverse(child);
        truncated += `</${tagName}>`;
      }
    }
  }

  function getAttributes(el) {
    return Array.from(el.attributes)
      .map((attr) => ` ${attr.name}="${attr.value}"`)
      .join("");
  }

  traverse(div);
  return truncated;
}
